import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useCallback, useState } from "react";

import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

export interface ContainerProps {
  children: React.ReactNode;
  collapsible?: boolean;
  defaultExpanded?: boolean;
  headerBackgroundColor?: string;
  subtitle?: string;
  textTransform?: string;
  title: string;
}

// TODO: add some smooth transition when expanding/collapsing
export const Container = ({
  title,
  subtitle,
  collapsible = true,
  defaultExpanded = false,
  children,
  headerBackgroundColor = "bg-secondary",
  textTransform = "uppercase",
}: ContainerProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggle = useCallback(() => setIsExpanded(!isExpanded), [isExpanded]);

  return (
    <div className="border-primary flex flex-col rounded-md border">
      <div
        className={classNames(
          "border-primary items-start rounded-t-md px-4 py-2",
          {
            "rounded-b-md": collapsible && !isExpanded,
            "border-b": !collapsible || isExpanded,
          },
          headerBackgroundColor,
        )}
      >
        <div className="flex flex-row justify-between items-center">
          <div>
            <Typography.LabelXxs
              weight="semibold"
              textTransform={textTransform}
            >
              {title}
            </Typography.LabelXxs>
            {subtitle && <Typography.BodyXs>{subtitle}</Typography.BodyXs>}
          </div>
          <div className="flex items-center">
            {collapsible && (
              <Button
                type="button"
                variant="tertiary"
                className="!p-0"
                onClick={toggle}
                data-testid="accordion-toggle"
              >
                <Icon
                  type={isExpanded ? "16-chevron-down" : "16-chevron-right"}
                  size={16}
                  viewBox="0 0 20 20"
                />
              </Button>
            )}
          </div>
        </div>
      </div>
      {(!collapsible || isExpanded) && children}
    </div>
  );
};
